import KeyAccessCheckList from './key_access_check_list';

export default KeyAccessCheckList;
